/*
 * GiftsnBoxes: add to bag without leaving the page (owner, 5 Oct 2026).
 *
 * Product cards (form[data-gnb-quick-add]) and the product page form
 * (form[data-gnb-ajax]) used to post straight to /cart, which took shoppers off
 * the page. Now they add through the AJAX cart API and open Dawn's bag drawer.
 *
 * "Buy now" (button[data-gnb-buy-now]) adds the item and goes to the bag's
 * delivery step, not straight to Shopify checkout: the delivery date, time,
 * packaging and card message are chosen there, and Shopify's checkout on this
 * plan cannot ask for them.
 *
 * 31 Oct: the drawer keeps Dawn's "is-empty" class from page load, which hides
 * the items on a shopper's first add (blank bag). Clear it before rendering.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }
  // On the bag page itself the drawer would update while the page's own items,
  // totals, packaging and cross-sell row stayed stale, so reload the page instead.
  function onCartPage() {
    var p = window.location.pathname.replace(root, '/');
    return p === '/cart' || p === '/cart/';
  }

  function showError(form, message) {
    var el = form.querySelector('[data-gnb-cart-error]') || document.getElementById('gnb-pd-err');
    if (el) { el.textContent = message; el.hidden = false; }
    else window.alert(message);
  }
  function clearError(form) {
    var el = form.querySelector('[data-gnb-cart-error]') || document.getElementById('gnb-pd-err');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  function post(body, isJson) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: isJson
        ? { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json', 'Content-Type': 'application/json' }
        : { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: isJson ? JSON.stringify(body) : body,
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Could not add this to your bag.');
        return json;
      });
    });
  }

  function add(form, opts) {
    var body = new FormData(form);
    var d = drawer();
    var wantSections = !!(d && !opts.buyNow && !onCartPage());
    // Corporate customization (snippets/corporate-customization.liquid, 25 Oct): the chosen
    // engraving / logo printing is a separate add-on product, added with the same quantity.
    var ccSel = form.querySelector('.cc-type');
    var ccOpt = ccSel && ccSel.value ? ccSel.options[ccSel.selectedIndex] : null;
    if (wantSections && !ccOpt) {
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
    }
    return post(body).then(function (json) {
      if (!ccOpt) return json;
      var box = form.querySelector('.cc-box');
      var details = (form.querySelector('.cc-text') || {}).value || '';
      var addon = {
        items: [{
          id: parseInt(ccOpt.dataset.variant, 10),
          quantity: parseInt(body.get('quantity'), 10) || 1,
          properties: { 'For': box ? box.dataset.ccProduct : '', 'Details': details.trim() },
        }],
      };
      if (wantSections) {
        addon.sections = 'cart-drawer,cart-icon-bubble';
        addon.sections_url = window.location.pathname;
      }
      return post(addon, true).then(function (json2) {
        return Object.assign({}, json, { sections: json2.sections });
      });
    });
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.innerHTML; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = 'Adding…'; }
    else { btn.disabled = false; btn.removeAttribute('aria-busy'); if (btn.dataset.label) btn.innerHTML = btn.dataset.label; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-gnb-quick-add], form[data-gnb-ajax]')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var buyNow = !!(btn && btn.hasAttribute('data-gnb-buy-now'));
    clearError(form);
    busy(btn, true);
    add(form, { buyNow: buyNow })
      .then(function (json) {
        if (buyNow) { window.location.href = root + 'cart?step=delivery'; return; }
        if (onCartPage()) { window.location.reload(); return; }
        busy(btn, false);
        var d = drawer();
        if (d && json.sections) {
          d.classList.remove('is-empty');
          d.renderContents(json);
        }
        else window.location.href = root + 'cart';
      })
      .catch(function (err) {
        // Buy now on something already in the bag (e.g. the last one in stock):
        // nothing more to add, so carry on to the delivery step instead of stopping.
        if (buyNow) {
          var id = String((form.querySelector('[name="id"]') || {}).value || '');
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var inBag = cart.items.some(function (i) { return String(i.variant_id) === id; });
            if (inBag) { window.location.href = root + 'cart?step=delivery'; return; }
            busy(btn, false); showError(form, err.message);
          }).catch(function () { busy(btn, false); showError(form, err.message); });
        }
        busy(btn, false);
        showError(form, err.message);
      });
  });
})();